module.exports = __webpack_public_path__ + "static/media/27OCHA3.2bea0e8b.jpg";